module.exports = __webpack_public_path__ + "static/img/DL.6bb3d611.png";